import React, { useState, useEffect } from 'react';
import { TituloMenu, ColFlex, RowStyle} from './style'
import './styles.css';
import { Row, Col,Input, Button, Modal, Drawer, Table, List, Icon,Card } from 'antd'
import FormAgregarCliente from './form/FormAgregarCliente';
import FormEditarCliente from './form/FormEditarCliente';
import useWindowSize from '../../assets/js/use-windows-size';
import { useSelector, useDispatch } from 'react-redux';
import { actionGetClientes, actionGetCliente, actionRegistrarCliente, actionEditarCliente } from '../../store/acciones/accionesClientes';

const { Search } = Input;

const Clientes = () => {

    const size = useWindowSize();
    const [visible, showModal] = useState(false)
    const [visibleSider, showSider] = useState(false)
    const [cliente, getCliente]=useState({})
    const [isMobile, windowResize] = useState(false)

    //Se obtienen los clientes  del servidor
    let clientes = useSelector(state => state.reducerClientes.clientes);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actionGetClientes());
        windowResize({ isMobile: size.width <= 360 ? true : false })
    }, [dispatch, size.width]);

    const registrarCliente = (values) => {
        setTimeout(() => {
            dispatch(actionRegistrarCliente(values))
            showModal(false)
        }, 500);
    }

    const openFormCliente = (cliente) => {
        dispatch(actionGetCliente(cliente.CODIGO));
        getCliente(cliente)
        showSider(true)
    }

    
    const editarCliente = (values) => {
        dispatch(actionEditarCliente(cliente.CODIGO, values))
        setTimeout(() => {
            showSider(false)
        }, 1000);
    }

    const filterClientes=(e)=>{
        dispatch(actionGetClientes(e.target.value))
   }

    const columns = [
        {
            title: 'Cliente',
            dataIndex: 'NOMBRE',
            key: 'NOMBRE'
        },
        {
            title: 'Codigo',
            dataIndex: 'CODIGO',
            key: 'CODIGO',
        },
        {
            title: 'Acciones',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <div>
                    <Button type="primary" onClick={() => openFormCliente(record)} icon="edit">Editar</Button>
                </div>
            ),
        },]

    return (
        <>
            <TituloMenu>Lista de clientes</TituloMenu>
            <RowStyle type="flex" justify="space-around" align="middle">
                <ColFlex xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Search placeholder="codigo, nombre, correo, direccion " onChange={(e)=>filterClientes(e)} enterButton />
                </ColFlex>
                <ColFlex xl={12} lg={12} md={12} sm={24} xs={24}>
                    <div>
                        <Button type="primary" icon="user-add" onClick={() => showModal(true)}>
                            Agregar Cliente
                        </Button>
                        <Modal
                            title="Agregar Cliente"
                            visible={visible}
                            onOk={() => showModal(false)}
                            onCancel={() => showModal(false)}
                            footer={null}
                            destroyOnClose
                        >
                            <FormAgregarCliente registro={registrarCliente} />
                        </Modal>
                    </div>
                </ColFlex>
            </RowStyle>

            <Row type="flex" justify="space-around" align="middle">
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    <div className="clientesResponsive">
                        <List
                     pagination={{
                        pageSize: 10,
                      }}
                        grid={{
                            gutter: 16,
                            xs: 1,
                            sm: 1,
                            md: 1,
                            lg: 1,
                            xl: 1,
                            xxl: 1,
                        }}
                        dataSource={clientes}
                        renderItem={item => (
                            <List.Item>
                                <Card>
                                    <Row type="flex" align="middle">
                                        <Col xl={20} lg={20} md={24} sm={24} xs={24} >
                                                <p>CLIENTE: <Icon type="user" style={{marginRight:".3em"}} /> <span>{item.NOMBRE}</span></p>
                                                <p>CODIGO: <span>({item.CODIGO} )</span></p> 
                                        </Col>
                                        <Col l={4} lg={4} md={24}  sm={24} xs={24} >
                                            <Button type="primary" onClick={()=>openFormCliente(item)}icon="edit">Editar</Button>
                                        </Col>
                                    </Row>
                                </Card>
                    
                            </List.Item>
                        )}
                    />
                    </div>
                    <div className="tableClientes">
                        <Table columns={columns} dataSource={clientes} rowKey="CODIGO" />
                    </div>
                    

                    

                    <Drawer
                        title="Editar Cliente"
                        placement="right"
                        closable={false}
                        onClose={() => showSider(false)}
                        visible={visibleSider}
                        width={isMobile.isMobile ? "90%" : "40%"}
                        destroyOnClose
                    >
                        <FormEditarCliente editar={editarCliente} />
                    </Drawer>
                </Col>
            </Row>
        </>
    );
};

export default Clientes;